// MUTATIONS
export const MUTATION_RESET_STATE                = 'resetStateMutation'

// ACTIONS
export const ACTION_RESET_STATE                = 'resetStateAction'
